import { render, staticRenderFns } from "./OTListEstimateSummary.vue?vue&type=template&id=6d22151b&lang=pug"
import script from "./OTListEstimateSummary.vue?vue&type=script&lang=js"
export * from "./OTListEstimateSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports